var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11 7C11 6.44769 11.4477 6 12 6C12.5523 6 13 6.44769 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7ZM11.1628 18.0829C11.4047 18.2943 11.6878 18.4 12.012 18.4C12.3256 18.4 12.602 18.293 12.8412 18.0789C13.0804 17.8649 13.2 17.5706 13.2 17.196C13.2 16.8589 13.0858 16.5753 12.8572 16.3452C12.6286 16.1151 12.3469 16 12.012 16C11.6718 16 11.3848 16.1151 11.1509 16.3452C10.917 16.5753 10.8 16.8589 10.8 17.196C10.8 17.5759 10.921 17.8716 11.1628 18.0829Z",
    fill: "currentColor"
  })));
}

export default SvgExclamationCircle;